"use client";

import React, { type ReactElement } from "react";
import {
  SitesMapLayerPoint,
  SitesMapLayerStation,
  SitesMapLayerZone,
} from "@/components";
import { useSites } from "src/hooks/sites";
import { SiteTypeEnum, type Site, type ThemeTypeEnum } from "@/types";

interface SitesMapLayerThemeProps {
  sites: Site[];
  theme: ThemeTypeEnum;
  interactive?: boolean;
}

function SitesMapLayerTheme({
  sites,
  theme,
  interactive = true,
}: Readonly<SitesMapLayerThemeProps>): ReactElement {
  const { filterSitesByType } = useSites(sites);

  const points = filterSitesByType(SiteTypeEnum.POINT);
  const stations = filterSitesByType(SiteTypeEnum.STATION);
  const zones = filterSitesByType(SiteTypeEnum.ZONE);

  return (
    <>
      <SitesMapLayerPoint
        sites={points}
        theme={theme}
        interactive={interactive}
      />
      <SitesMapLayerStation
        sites={stations}
        theme={theme}
        interactive={interactive}
      />
      <SitesMapLayerZone
        sites={zones}
        theme={theme}
        interactive={interactive}
      />
    </>
  );
}

export { SitesMapLayerTheme, type SitesMapLayerThemeProps };
